import {Component, OnInit} from '@angular/core';
import {HealthGroupRequest, HealthGroupScenario} from '../../../model/HealthGroupModel';
import {StaticMethods, UploadInfo} from '../../../model/GeneralModels';
import {HealthGroupService} from '../../../services/health-group.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AppSettingsService} from '../../../services/app-settings.service';
import {FileService} from '../../../services/file.service';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: [
    '../../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css',
  ],
})
export class DetailsComponent implements OnInit {
  icon = null;
  requestID: number;
  downloadExcelEnabled = false;
  requestInfo: HealthGroupRequest[] = [];
  buttonLabel: string;
  productName = 'HEALTH_GROUP';
  translation: any = {};
  paymentMode = false;
  fileInfo: UploadInfo;

  constructor(private service: HealthGroupService,
              private fileService: FileService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private settings: AppSettingsService) {
  }

  ngOnInit(): void {
    if (StaticMethods.checkState(this.router, 'requestID', `/${this.productName}/requests`)) {
      this.requestID = history.state.requestID;
      this.getRequestInfo();
    }
  }

  setButton(request: HealthGroupRequest) {
    switch (request.currentStep) {
      case HealthGroupScenario.paid:
        this.buttonLabel = 'پرداخت حق بیمه';
        break;
      case HealthGroupScenario.dataFileSubmission:
        this.buttonLabel = 'اپلود فایل اطلاعات';
        this.downloadExcelEnabled = true;
        break;
      case HealthGroupScenario.waitingForRelease:
        this.buttonLabel = '';
        break;
      case HealthGroupScenario.insuranceReleased:
        this.buttonLabel = 'دانلود بیمه نامه';
        break;
    }
  }

  takeAction() {
    switch (this.requestInfo[0].currentStep) {
      case HealthGroupScenario.paid:
        this.showPaymentPanel();
        break;
      case HealthGroupScenario.dataFileSubmission:
        // TODO download default file
        this.fileInfo = {
          englishName: 'DataFile',
          persianName: this.settings.translateEnglish('DataFile', this.translation),
          id: this.requestID
        };
        break;
      case HealthGroupScenario.insuranceReleased:
        this.download();
        break;
    }
  }

  showPaymentPanel() {
    this.router.navigate([`/invoice/${this.productName}/${this.requestID}`]);
  }

  hideFinance() {
    this.paymentMode = false;
  }

  getRequestInfo() {
    this.service.getRequestInfo(this.requestID).subscribe(response => {
      if (response.success) {
        this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
        let scenario;
        switch (response.data.clientType) {
          case 'B2B':
            scenario = HealthGroupScenario.B2BScenario;
            break;
          default:
            scenario = HealthGroupScenario.generalScenario;
        }
        this.requestInfo = [
          new HealthGroupRequest(response.data, scenario)
        ];
        this.setButton(this.requestInfo[0]);
      }
    }, error => {
      this.router.navigate([`/${this.productName}/requests`]);
    });
  }

  hideUploadPanel() {
    this.fileInfo = null;
  }

  private download() {
    this.fileService.downloadReleased(this.requestID, this.productName).subscribe(response => {
      if (response.success) {
        StaticMethods.goToLink(response.data.directLink);
      }
    });
  }

  downloadExcelTemplate() {
    this.fileService.downloadTemplateFile(this.productName).subscribe(response => {
      if (response.success) {
        StaticMethods.goToLink(response.data.directLink);
      }
    });
  }
}
